export const API_BASE_URL = 'https://sapi-dev.quik.vn/api/v1';
